// extracted by mini-css-extract-plugin
export var body = "_lb-0";
export var sectionHeader = "_lb-4";
export var shortcutColumns = "_lb-2";
export var shortcutList = "_lb-1";
export var shortcutSection = "_lb-3";